import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import {DeereFetch} from '../../../shared/fetch';
import styles from './index.css';
import {Card, Col, Row} from '@deere/ux.uxframe-react';

export const MissingProposalStatus = () => {
    const [disable, setDisable] = useState(false);

    const processMissingBundle = () => {
        setDisable(true)
        DeereFetch('/api/missing-proposal-status', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: {}
        });
    }

    return (
        <Card>
            <Card.Body>
                <Row>
                    <Col>
                        <div className={styles.header}>
                            Missing Proposal Status Update
                        </div>
                    </Col>
                    <Col>
                        <Button
                            color="primary"
                            disabled={disable}
                            onClick={() => processMissingBundle()}
                            size="large"
                            variant="contained"
                        >
                            Process
                        </Button>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};
